import me from "models/me";

export default function (nextState, replace, callback) {
    if (me.actual_user) {
        replace({ pathname: "/404" });
    }

    callback();
}
